import Ebony9Attic1 from "../Ebony/Ebony 9 Attic.png"
import Ebony9Attic2 from "../Ebony/Ebony 9 Attic.png"

const Ebony9Atticimages =[
    Ebony9Attic1,Ebony9Attic2
]

export default Ebony9Atticimages;